<!-- Fixed Header -->
<div class="dialog-header d-flex justify-content-between align-items-center">
  <div class="d-flex align-items-center header-left">
    <div class="icon-circle me-3">
      <mat-icon class="text-primary">how_to_reg</mat-icon>
    </div>
    <div class="header-text">
      <h3 class="dialog-title mb-0">Registered Product Details</h3>
      <div class="dialog-subtitle text-muted">Customer registration, location & warranty history</div>
    </div>
  </div>
  <button mat-icon-button (click)="onClose()" aria-label="Close" class="close-btn me-n1">
    <mat-icon>close</mat-icon>
  </button>
</div>

<!-- Scrollable Content Body -->
<mat-dialog-content class="dialog-content-body">
  <!-- Summary Card -->
  <div class="summary-card mb-3">
    <div class="d-flex flex-wrap justify-content-between align-items-start gap-2">
      <div>
        <span class="text-uppercase tracking-wider text-muted font-11 fw-bold">Serial Number / Registered Code</span>
        <div class="serial-code mt-1">{{ data.productCode }}</div>
        <div class="product-title mt-1">
          {{ data.productName || 'Unknown Product' }}
        </div>
        <div class="product-category text-muted mt-1" *ngIf="data.categoryName || data.productSKU">
          <span *ngIf="data.productSKU" class="badge bg-light text-secondary border me-2">SKU: {{ data.productSKU }}</span>
          <span *ngIf="data.categoryName"><mat-icon class="inline-icon">category</mat-icon> {{ data.categoryName }}</span>
        </div>
      </div>

      <div class="d-flex flex-column align-items-end gap-1">
        <span class="status-pill" [ngClass]="data.isCurrentlyEligible ? 'status-eligible' : 'status-ineligible'">
          <mat-icon class="status-icon">{{ data.isCurrentlyEligible ? 'verified' : 'history' }}</mat-icon>
          {{ data.isCurrentlyEligible ? 'In Warranty' : 'Expired' }}
        </span>
        <span class="status-pill" [ngClass]="data.isClaimed ? 'status-claimed' : 'status-unclaimed'">
          <mat-icon class="status-icon">{{ data.isClaimed ? 'fact_check' : 'pending_actions' }}</mat-icon>
          {{ data.isClaimed ? 'Claimed' : 'Unclaimed' }}
        </span>
      </div>
    </div>
  </div>

  <!-- Customer Information Grid -->
  <div class="section-label mb-2">
    <mat-icon class="section-icon">account_circle</mat-icon> Customer Information
  </div>
  <div class="customer-card mb-3">
    <div class="customer-grid">
      <div class="customer-item">
        <span class="item-label">Customer Name</span>
        <span class="item-value text-primary fw-bold">{{ data.user?.username || 'N/A' }}</span>
      </div>
      <div class="customer-item">
        <span class="item-label">Phone Number</span>
        <span class="item-value">{{ data.user?.phone || 'N/A' }}</span>
      </div>
      <div class="customer-item">
        <span class="item-label">Company Name</span>
        <span class="item-value">{{ data.user?.companyName || '-' }}</span>
      </div>

      <div class="customer-item highlight-location">
        <span class="item-label text-danger">City</span>
        <span class="item-value fw-bold text-dark">{{ data.user?.city || '-' }}</span>
      </div>
      <div class="customer-item highlight-location">
        <span class="item-label text-danger">State</span>
        <span class="item-value fw-bold text-dark">{{ data.user?.state || '-' }}</span>
      </div>
      <div class="customer-item highlight-location">
        <span class="item-label text-danger">Pincode</span>
        <span class="item-value fw-bold text-dark">{{ data.user?.pincode || '-' }}</span>
      </div>
    </div>
  </div>

  <!-- Timeline Dates Grid -->
  <div class="section-label mb-2">
    <mat-icon class="section-icon">schedule</mat-icon> Timeline Dates
  </div>
  <div class="dates-grid mb-3">
    <!-- Registration Date -->
    <div class="date-card highlight-reg">
      <span class="date-label text-primary">Registration Date</span>
      <div class="date-value text-primary">{{ (data.registeredDate | date : 'dd/MM/yyyy') || 'N/A' }}</div>
      <span class="date-sub">{{ (data.registeredDate | date : 'hh:mm a') || '' }}</span>
    </div>

    <!-- Mfg Date -->
    <div class="date-card">
      <span class="date-label">Manufacturing</span>
      <div class="date-value">{{ (data.mfgDate | date : 'dd/MM/yyyy') || 'N/A' }}</div>
    </div>

    <!-- Last Eligible Date -->
    <div class="date-card highlight-limit">
      <span class="date-label text-danger">Warranty Ends</span>
      <div class="date-value text-danger">{{ (data.lastEligibleDate | date : 'dd/MM/yyyy') || 'N/A' }}</div>
    </div>

    <!-- Claim Date -->
    <div class="date-card" [ngClass]="data.isClaimed ? 'highlight-claim' : ''">
      <span class="date-label">Claim Date</span>
      <div class="date-value" [ngClass]="data.isClaimed ? 'text-primary' : 'text-muted'">
        {{ (data.claimDate | date : 'dd/MM/yyyy') || 'Not Claimed' }}
      </div>
    </div>
  </div>

  <!-- Warranty Rule Card (if available) -->
  <div class="rule-card mb-2" *ngIf="data.ruleDescription">
    <div class="d-flex align-items-start">
      <mat-icon class="rule-icon me-2">rule</mat-icon>
      <div class="flex-grow-1">
        <div class="d-flex flex-wrap align-items-center justify-content-between gap-2">
          <span class="fw-semibold text-dark font-13">Warranty Calculation Rule:</span>
          <span class="rule-badge" [ngClass]="data.ruleApplied?.includes('MFG') ? 'rule-mfg' : 'rule-reg'">
            {{ data.ruleDescription }}
          </span>
        </div>
      </div>
    </div>
  </div>
</mat-dialog-content>

<!-- Fixed Footer -->
<div class="dialog-footer d-flex justify-content-end align-items-center">
  <button mat-flat-button color="primary" class="close-action-btn" (click)="onClose()">
    Close
  </button>
</div>
